import { useEventListener } from 'usehooks-ts'

/** Cmd/Ctrl+Enter anywhere on the page. Skipped when a widget already handled Enter (cmdk does). */
export function useSaveShortcut(onSave: () => void) {
  useEventListener('keydown', (event) => {
    if (event.key !== 'Enter' || !(event.metaKey || event.ctrlKey)) return
    if (event.defaultPrevented || event.repeat) return
    event.preventDefault()
    onSave()
  })
}
